export default __webpack_public_path__ + "static/media/cube-cum.ecbefdfd.png";